module.exports = __webpack_public_path__ + "static/media/fastWindow.e49c021b.jpg";